import { Controller } from "@hotwired/stimulus"
import flash from "../lib/flashes.js"

export default class extends Controller {
  static targets = ["submitButton"]
  static values = {
    optimisticRemove: Boolean,
    successMessage: String,
  }

  validate(event) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = event.target.value !== "DELETE"
    }
  }

  async submit(event) {
    if (!this.optimisticRemoveValue) return

    event.preventDefault()

    const form = event.target
    const formData = new FormData(form)
    const ids = this.parseIds(formData.get("ids"))

    try {
      const response = await fetch(form.action, {
        method: form.method || "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: formData,
      })

      let responseData = null
      try {
        responseData = await response.json()
      } catch (_parseError) {
        responseData = null
      }

      if (!response.ok) {
        throw new Error(responseData?.error || responseData?.message || "Failed to update selected item(s)")
      }

      this.removeSelectedGridItems(ids)
      this.clearSelection()
      this.closeModal()
      flash(responseData?.message || this.successMessageValue || "Selected item(s) queued for deletion", "success")
    } catch (error) {
      flash(`Failed to update selected item(s): ${error.message}`, "error")
    }
  }

  parseIds(ids) {
    try {
      return JSON.parse(ids || "[]")
    } catch (_parseError) {
      return []
    }
  }

  clearSelection() {
    const bulkSelectorElement = document.querySelector('[data-controller*="bulk-selector"]')
    if (!bulkSelectorElement) return

    const bulkSelectorController = this.application.getControllerForElementAndIdentifier(bulkSelectorElement, "bulk-selector")
    bulkSelectorController?.clearSelection()
  }

  closeModal() {
    const modalElement = this.element.closest('[data-controller*="turbo-modal"]')
    if (!modalElement) return

    const modalController = this.application.getControllerForElementAndIdentifier(modalElement, "turbo-modal")
    modalController?.hideModal()
  }

  removeSelectedGridItems(ids) {
    ids.forEach((id) => {
      const checkbox = document.querySelector(`input.bulk-select-checkbox[data-item-id="${id}"]`)
      const item = checkbox?.closest(".grid-item") || checkbox?.closest("tr")
      if (item) {
        item.remove()
      }
    })
  }
}
